import ProgressBar from 'progressbar.js';
import type SemiCircle from 'progressbar.js/semicircle.js';
import { useLayoutEffect, useState } from 'react';

type Props = {
    progress?: number;
    height?: number;
    width?: number;
};

export function ProgressSemiCircleChart({ progress = 1.5 }: Props) {
    const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null);

    useLayoutEffect(() => {
        if (!containerRef) {
            return;
        }

        const bar = new ProgressBar.SemiCircle(containerRef, {
            strokeWidth: 10,
            color: '',
            trailColor: 'rgba(168, 206, 255, 1)',
            trailWidth: 10,
            easing: 'easeInOut',
            duration: 1400,
            svgStyle: {
                display: 'block',
                stroke: ' rgba(51, 141, 255, 1)',
                strokeWidth: 10,
                strokeLinecap: 'round',
                width: '120px',
                height: '75px',
            },
            text: {
                alignToBottom: true,
                style: {
                    fontSize: '18px',
                    lineHeight: '28px',
                    fontWeight: '700',
                    fontFamily: '"__Inter_aaf875", Helvetica, sans-serif',
                    position: 'absolute',
                    left: '50%',
                    top: 'auto',
                    margin: 0,
                    padding: 0,
                },
            },
            step: (state, path) => {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
                const bar = path as SemiCircle;
                const value = Math.round(bar.value() * 100);
                bar.setText(`${value}%`);

                if (bar.value() > 1) {
                    bar.trail?.setAttribute('stroke', 'rgba(51, 141, 255, 1)');
                }
            },
        });

        bar.animate(progress);

        return () => {
            bar.destroy();
        };
    }, [containerRef, progress]); // Re-run effect if 'progress' prop changes

    return (
        <div className="-mt-1">
            <div ref={setContainerRef} />
        </div>
    );
}
